// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a6a97343","897":"4c98e825"}[chunkId] + ".chunk.js";
};